import styled from 'styled-components';
import { MenuItem } from '@material-ui/core';

export const RawMenuItem = styled(MenuItem)`
  padding: 0;
`;
